export default {
  html: {
    id: 'cs_test_123456',
    object: 'checkout.session',
    allow_promotion_codes: null,
    amount_subtotal: 2000,
    amount_total: 2000,
    billing_address_collection: null,
    cancel_url: 'http://localhost:4242/cancel.html',
    client_reference_id: null,
    currency: 'usd',
    customer: null,
    customer_email: null,
    livemode: false,
    locale: null,
    metadata: {},
    mode: 'payment',
    payment_intent: 'pi_123456',
    payment_method_types: ['card'],
    setup_intent: null,
    shipping: null,
    shipping_address_collection: null,
    submit_type: null,
    subscription: null,
    success_url: 'http://localhost:4242/success.html',
    total_details: {
      amount_discount: 0,
      amount_tax: 0,
    },
  },
  react: {
    id: 'cs_test_123456',
    object: 'checkout.session',
    allow_promotion_codes: null,
    amount_subtotal: 2000,
    amount_total: 2000,
    billing_address_collection: null,
    cancel_url: 'http://localhost:3000/checkout?canceled=true',
    client_reference_id: null,
    currency: 'usd',
    customer: null,
    customer_email: null,
    livemode: false,
    locale: null,
    metadata: {},
    mode: 'payment',
    payment_intent: 'pi_123456',
    payment_method_types: ['card'],
    setup_intent: null,
    shipping: null,
    shipping_address_collection: null,
    submit_type: null,
    subscription: null,
    success_url: 'http://localhost:3000/checkout?success=true',
    total_details: {
      amount_discount: 0,
      amount_tax: 0,
    },
  },
};
